
import { TweenMax, TimelineMax } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import CSSRulePlugin from 'gsap/CSSRulePlugin';
import TweenLite from 'gsap/TweenLite';
import CustomEase from 'gsap/CustomEase';

import axios from "axios";

import Swiper from "swiper";

import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';

import VueMq from 'vue-mq';

Vue.use(VueMq, {
    breakpoints: {
        mobile: 1024,
        desktop: 1025
    }
})

window.VueMq = VueMq;
window.axios = axios;
window.Vue = Vue;
window.Vuex = Vuex;
window.TweenMax = TweenMax;
window.TweenLite = TweenLite;
window.TimelineMax = TimelineMax;
window.ScrollToPlugin = ScrollToPlugin;
window.CSSRulePlugin = CSSRulePlugin;
window.CustomEase = CustomEase;

window.Swiper = Swiper;
window.moment = moment;

require("./vue/vue.js");
require("./components/attractHover.js");
require("./components/global.js");
require("./components/header.js");


$(document).ready(function(){
    if( 'IntersectionObserver' in window ){
        $('body').addClass('can-animate');
    } else {
        $('body').addClass('cannot-animate');
    }
}); //document ready